import React from "react";
import { dataUser } from "../services/Cache/Auth";
import { SettingOutlined, ChromeFilled, LogoutOutlined, UserAddOutlined } from '@ant-design/icons';
import { Badge, Menu } from 'antd';
import { Link } from "react-router-dom";

// import profil_img from "../asset/img/menu/profile.png"
import profil_img  from "../assets/img/menu/profile.png"


function _Nav() {
  const { SubMenu } = Menu;

  return (
    <Menu mode="horizontal" style={{
      borderColor: "#77B0AA",
      backgroundImage: "linear-gradient(0deg, rgba(227,254,247,1) 26%, rgba(119,176,170,1) 100%)",
    }}>
      <Menu.Item key="113"></Menu.Item>
      <Menu.Item key="1123"></Menu.Item>
      <Menu.Item key="11334d"></Menu.Item>
      <Menu.Item key="11ass"></Menu.Item>
      <Menu.Item key="home" icon={<ChromeFilled />}>
        <Link to="home" > Home </Link>
      </Menu.Item>

      {
        dataUser.user?.role === "adm" ?
          <Menu.Item key="33" icon={<ChromeFilled />}>
            <Link to="RiwayatKonselingGizi" > Riwayat Konseling Gizi     </Link>
            <Badge count={2} offset={[0, -25]}>
            </Badge>
          </Menu.Item> :
          <Menu.Item key="33223" icon={<ChromeFilled />}>
            <Link to="RiwayatKonseling" > Riwayat Konseling     </Link>
          </Menu.Item>
      }
      <Menu.Item key="laporan" icon={<UserAddOutlined />}>
        <Link to="/OrderKonselingManual">Konseling Baru </Link>
      </Menu.Item>
      <SubMenu key="sub7"
        icon={<SettingOutlined />}
        title="Diet"
      >
        <Menu.Item key="71-2" icon={<SettingOutlined />}> <Link to={"/MappDiet"}>   Data Diet </Link></Menu.Item>
        <Menu.Item key="71-1" icon={<SettingOutlined />}> <Link to={"/BuatDiet"}>   Buat Diet </Link></Menu.Item>
      </SubMenu>

      <SubMenu key="sub8"
        icon={<img src={profil_img} width={30} alt="Profile" />}
        title={dataUser.user?.namaexternal}
      >
        <Menu.Item key="81-1" icon={<LogoutOutlined />}> <Link to={"/login"}>   Logout </Link></Menu.Item>
      </SubMenu>

    </Menu>
  );
}

export default _Nav;
